// 公共类型定义（分页、状态等）
// 通用状态枚举
export var GeneralStatus;
(function (GeneralStatus) {
    GeneralStatus[GeneralStatus["ACTIVE"] = 1] = "ACTIVE";
    GeneralStatus[GeneralStatus["INACTIVE"] = 0] = "INACTIVE";
    GeneralStatus[GeneralStatus["DELETED"] = -1] = "DELETED";
})(GeneralStatus || (GeneralStatus = {}));
// 导出任务状态
export var ExportStatus;
(function (ExportStatus) {
    ExportStatus["PENDING"] = "pending";
    ExportStatus["PROCESSING"] = "processing";
    ExportStatus["COMPLETED"] = "completed";
    ExportStatus["FAILED"] = "failed";
    ExportStatus["CANCELLED"] = "cancelled";
})(ExportStatus || (ExportStatus = {}));
// 统计时间范围
export var StatsPeriod;
(function (StatsPeriod) {
    StatsPeriod["TODAY"] = "today";
    StatsPeriod["YESTERDAY"] = "yesterday";
    StatsPeriod["LAST_7_DAYS"] = "last_7_days";
    StatsPeriod["LAST_30_DAYS"] = "last_30_days";
    StatsPeriod["THIS_MONTH"] = "this_month";
    StatsPeriod["LAST_MONTH"] = "last_month";
    StatsPeriod["THIS_YEAR"] = "this_year";
    StatsPeriod["CUSTOM"] = "custom";
})(StatsPeriod || (StatsPeriod = {}));
// 通用状态枚举
export const COMMON_STATUS = {
    ACTIVE: 1,
    INACTIVE: 0,
    DELETED: -1,
};
// HTTP 方法枚举
export const HTTP_METHODS = {
    GET: 'GET',
    POST: 'POST',
    PUT: 'PUT',
    DELETE: 'DELETE',
    PATCH: 'PATCH',
    HEAD: 'HEAD',
    OPTIONS: 'OPTIONS',
};
// MIME 类型常量
export const MIME_TYPES = {
    JSON: 'application/json',
    XML: 'application/xml',
    HTML: 'text/html',
    TEXT: 'text/plain',
    CSV: 'text/csv',
    PDF: 'application/pdf',
    EXCEL: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    ZIP: 'application/zip',
    IMAGE_JPEG: 'image/jpeg',
    IMAGE_PNG: 'image/png',
    IMAGE_GIF: 'image/gif',
    IMAGE_WEBP: 'image/webp',
};
//# sourceMappingURL=common.js.map